export const wordSelected = (word) => ({
	type: 'WORD_SELECTED',
	word
});


// WEBPACK FOOTER //
// ./src/actions/word.js